import React from 'react';

const AnnualTable = ({ annualData }) => {

    let slno =1;
    // Your conversion logic
    const convertedArray = annualData.reduce((result, entry) => {
        // Find existing entry based on student_uid, academic_year, and te
        const existingEntry = result.find(item => 
            item.student_uid === entry.student_uid &&
            item.academic_year === entry.academic_year &&
            item.te === entry.te
        );
    
        // If an existing entry is found, add the score details to its scores array
        if (existingEntry) {
            existingEntry.scores.push({
                subject_name: entry.subject_name,
                subject_code: entry.subject_code,
                score: entry.score
            });
        } else {
            // If no existing entry is found, create a new entry with scores array
            const newEntry = {
                // student_name: entry.student_name.split(' ')[0], // Extract first name
                student_name: entry.student_name,
                student_uid: entry.student_uid,
                academic_year: entry.academic_year,
                te: entry.te,
                scores: [
                    {
                        subject_name: entry.subject_name,
                        subject_code: entry.subject_code,
                        score: entry.score
                    }
                ]
            };
            result.push(newEntry);
        }
    
        return result;
    }, []);

    if (convertedArray.length === 0) {
        return <p>No data available.</p>;
    }

    return (
        <>
            <table className='table table-bordered'>
                <thead>
                    <tr className='table-dark'>
                        <th className='text-light'>Name</th>
                        <th className='text-light'>UID</th>
                        <th className='text-light'>Academic Year</th>
                        <th className='text-light'>Assessment</th>
                    </tr>
                </thead>
                <tbody>
                    {convertedArray.map((entry, index) => (
                        <tr key={index}>
                            <td className='text-dark'>{entry.student_name}</td>
                            <td className='text-dark'>{entry.student_uid}</td>
                            <td className='text-dark'>{entry.academic_year}</td>
                            <td className='text-dark'>{entry.te}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <table className='table table-bordered border border-dark'>
                <thead>
                    <tr className='table-dark'>
                        <th className='text-light'>Sl.No.</th>
                        <th className='text-light'>FM</th>
                        
                        <th className='text-light'>PM</th>
                        <th className='text-light'>Subject</th>
                        <th className='text-light'>Secured Marks</th>
                    </tr>
                </thead>
                <tbody>
                    {convertedArray.map((entry, index) => (
                        <tr key={index}>
                           <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {slno ++}
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        100
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        33
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>{entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {score.subject_name}
                                    </div>
                                ))}
                            </td>
                            <td className='text-dark'>
                                {entry.scores.map((score, scoreIndex) => (
                                    <div key={scoreIndex}>
                                        {score.score}
                                    </div>
                                ))}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default AnnualTable
